<template>
  <a-tooltip>
    <button :class="{'more-than-one': hasMoreThanOne}" @click="handleClick">
      <span class="attachable-count" v-if="hasMoreThanOne">{{count}}</span>
      <span class="icon-wrapper transition-fast" >
        <slot name="icon">
          <!-- Fallback Icon-->
          <i class="fallback-icon " :class="icon"></i>
        </slot>
    </span>
    </button>
    <template #title>
      <slot></slot>
    </template>
  </a-tooltip>

</template>

<script>
export default {
  name: "TaskButton.vue",
  props: {
    icon: {
      type: String,
      required: false,
    },
    href: {
      type: String,
      required: false,
    },
    count: {
      type: Number,
      required: false,
      default: 0,
    }
  },
  computed: {
    hasMoreThanOne() {
      return this.count > 0;
    },
  },
  methods:{

    handleClick() {
      this.$emit('click');
      if ( this.href ){
        window.location.href = this.href;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

button {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: $font-size-small;
  border-radius: 9999px;
  padding: $spacing-md;
  color: white;
  box-shadow: $shadow-lg;
  height: $spacing-xl;
  width: $spacing-xl;
  border: 0;
}

.more-than-one {
  i {
    color: white;
  }
  .attachable-count {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items:center;
    right: -8px;
    top: -8px;
    font-size: 13px;
    background-color: $brand-danger;
    color: white;
    border-radius: 9999px;
    height: $font-size-large;
    width: $font-size-large;
  }
}

.create-note-button {
  background-color: $brand-primary;
}
.create-task-button {
  background-color: $blue-dark;
}
.create-email-button {
  background-color: #2176FF;
}
.create-appointment-button {
  background-color: $brand-info;

}
.create-letter-button {
  background-color: #33A1FD;
}
</style>
